<template>
  <div id="component-bind-modal">
    <v-dialog
      transition="dialog-top-transition"
      v-model="showModal"
      width="auto"
      persistent
      no-click-animation
    >
      <v-card height="auto">
        <component
          v-bind:is="component.bind.is"
          v-bind="component.bind"
          v-on="component.on"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'ComponentBindModal',
  components: {},
  props: {
    component: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  data() {
    return {
      showModal: false,
    }
  },
  created() {
    this.showModal = true;
  },
};
</script>

<style lang="scss" scoped>
.component-bind-modal {
  max-width: fit-content;
}
</style>
